/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticketspayoutsown2Inputs */

const en_ticketspayoutsown2 = /** @type {(inputs: Ticketspayoutsown2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This profile has its own payout account.`)
};

const de_ticketspayoutsown2 = /** @type {(inputs: Ticketspayoutsown2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dieses Profil hat ein eigenes Auszahlungskonto.`)
};

/**
* | output |
* | --- |
* | "This profile has its own payout account." |
*
* @param {Ticketspayoutsown2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketspayoutsown2 = /** @type {((inputs?: Ticketspayoutsown2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketspayoutsown2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketspayoutsown2(inputs)
	return de_ticketspayoutsown2(inputs)
});
export { ticketspayoutsown2 as "ticketsPayoutsOwn" }